import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDropDown]',
  standalone: true
})
export class DropDownDirective {
  @Input() wasInside: boolean = false;

  constructor(private eRef: ElementRef) { }

  @HostBinding('class.active') isOpen = false;

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = !this.isOpen;
    } else {
      this.isOpen = false;
    }
  }
}
